import '../scss/section-main-product.scss';
// import '../../node_modules/swiper/swiper.scss';

import Swiper from 'swiper';
import { Navigation, Controller, Thumbs, Autoplay } from 'swiper/modules';

if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.mainSlider = this.querySelector('.productGallery__main');
        this.mainSlider_slider = this.mainSlider.querySelector('.productGallery__main__slider');
        this.sliderThumb = this.querySelector('.productGallery__thumbs');
        this.sliderThumb_slider = this.sliderThumb.querySelector('.productGallery__thumbs__slider');
        // this.productMedias = this.querySelectorAll('.product__media');
        this.isSwiperThumb = null;
        this.isSwiperMain = null;
        this.bp = window.matchMedia('screen and (min-width: 500px)');
        // this.bpTablet = window.matchMedia('screen and (min-width: 750px) and (max-width: 990px)');
        // this.bpDesktop = window.matchMedia('screen and (min-width: 500px)');
        this.currentHeight = window.innerHeight;
        this.currentWidth = window.innerWidth;
        this.isPortrait = window.innerHeight > window.innerWidth;

        window.addEventListener('DOMContentLoaded', () => {
          this.init();
        });
      }

      init() {
        if (!this.mainSlider) return;
        if (!this.sliderThumb) return;

        this.initSliders();

        // window.addEventListener('resize', () => {
        //   const newHeight = window.innerHeight;
        //   const newWidth = window.innerWidth;
        //   const newIsPortrait = window.innerHeight > window.innerWidth;

        //   if (newHeight !== this.currentHeight && newWidth === this.currentWidth) return;

        //   // if (window.orientation === 90 || window.orientation === -90) {
        //   //   this.currentWidth = newWidth;
        //   // }

        //   // if (window.orientation === 0 || window.orientation === 180) {
        //   //   this.currentWidth = newWidth;
        //   // }

        //   // console.log(this.lastWidth, newWidth);

        //   if (this.bp.matches) {
        //     clearTimeout(window.swiperResizeTimeout);

        //     window.swiperResizeTimeout = setTimeout(() => {
        //       this.initSliders();
        //     }, 200);
        //   }
        // });

        window.addEventListener('orientationchange', () => {
          // console.log('orientation change');
          this.handleOrientation();
        });
        screen.orientation?.addEventListener('change', () => {
          // console.log('orientation change');
          this.handleOrientation();
        });
      }

      handleOrientation() {
        clearTimeout(window.swiperResizeTimeout);

        window.swiperResizeTimeout = setTimeout(() => {
          this.initSliders();
        }, 200);
      }

      initSliders() {
        // console.log('Init sliders');
        const direction = this.bp.matches ? 'vertical' : 'horizontal';

        // console.log(this.bp.matches, this.isSwiperThumb);

        if ((!this.bp.matches && this.isSwiperThumb) || (this.bp.matches && this.isSwiperThumb)) {
          this.destroyThumSlider();
          this.destroyMainSlider();
        }

        // if (this.bpDesktop.matches && this.isSwiperThumb) {
        //   this.destroyThumSlider();
        // }

        // if (!this.bpTablet.matches && this.isSwiperThumb) {
        //   this.destroyThumSlider();
        // }

        // if (!this.bp.matches && this.isSwiperMain) {
        //   this.destroyMainSlider();
        // }

        this.initThumbslider(direction);
        this.initMainSlider();

        // if (this.bp.matches && !this.isSwiperThumb) {
        //   this.initThumbslider(direction);
        // } else if (!this.bp.matches && this.isSwiperThumb) {
        //   this.destroyThumSlider();
        // }

        // if (this.bp.matches && !this.isSwiperMain) {
        //   this.initMainSlider();
        // } else if (!this.bp.matches && this.isSwiperMain) {
        //   this.destroyMainSlider();
        // }
      }

      initMainSlider() {
        this.isSwiperMain = new Swiper(this.mainSlider_slider, {
          modules: [Navigation, Controller, Thumbs],
          slidesPerView: 1,
          // autoHeight: true,
          loop: true,
          initialSlide: 0,
          watchOverflow: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          preventInteractionOnTransition: true,
          grabCursor: true,
          autoHeight: true,
          thumbs: {
            swiper: this.isSwiperThumb,
          },
          navigation: {
            nextEl: this.mainSlider.querySelector('.slider-button--next'),
            prevEl: this.mainSlider.querySelector('.slider-button--prev'),
          },
          // breakpoints: {
          //   991: {
          //     autoHeight: false,
          //   },
          // },
        });
      }

      destroyMainSlider() {
        this.isSwiperMain.destroy(true, true);
        this.isSwiperMain = null;
      }

      initThumbslider(direction) {
        this.isSwiperThumb = new Swiper(this.sliderThumb_slider, {
          modules: [Navigation, Controller, Thumbs],
          spaceBetween: 10,
          slidesPerView: 5,
          // watchOverflow: true,
          grabCursor: true,
          direction: direction,
          centeredSlidesBounds: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          slideToClickedSlide: true,
          initialSlide: 0,
          // loopAdditionalSlides: 2,
          navigation: {
            nextEl: this.sliderThumb.querySelector('.productGallery__thumbs__next'),
            prevEl: this.sliderThumb.querySelector('.productGallery__thumbs__prev'),
          },
          breakpoints: {
            500: {
              spaceBetween: 15,
              slidesPerView: 4,
            },
            991: {
              spaceBetween: 20,
              slidesPerView: 4,
            },
          },
          on: {
            init: (swiper) => {
              const slidesPerView = swiper.params.slidesPerView;

              if (swiper.params.slidesPerView == 'auto') return;

              if (this.bp.matches) {
                this.getSliderThumbHeight(swiper);
              }
            },
          },
        });
      }

      destroyThumSlider() {
        this.isSwiperThumb.destroy(true, true);
        this.isSwiperThumb = null;
        this.sliderThumb.style.height = '100%';
      }

      getSliderThumbHeight(swiper) {
        const slidesPerView = swiper.params.slidesPerView;
        const spaceBetween = swiper.params.spaceBetween;

        // let slideHeight = 0;
        // let higherSlide;

        // const mainSliderFirstSlide = this.mainSlider.querySelector('.product-media-container');
        // const thumbSliderNavigationBtn = this.sliderThumb.querySelector('.slider-button').offsetHeight;
        // console.log(thumbSliderNavigationBtn);

        // sliderImages.forEach((slide) => {
        //   const currentSlide = slide.querySelector('.product__media img');
        //   const currentSlideHeight = currentSlide.offsetHeight;

        //   // console.log(currentSlide);

        //   if (currentSlideHeight > slideHeight) {
        //     slideHeight = currentSlideHeight;
        //     higherSlide = currentSlide;
        //   }
        // });

        const mainSliderFirstSlideHeight = this.mainSlider.querySelector('.product__media-item').offsetHeight;

        // console.log(mainSliderFirstSlideHeight); // 739

        const thumbSlideHeight = this.sliderThumb.querySelector(
          '.product__sliderThumb__list__item .thumbnail'
        ).offsetHeight;

        // console.log(mainSliderFirstSlideHeight, spaceBetween);

        const thumbSlideTotalHeight = thumbSlideHeight + spaceBetween; // 123
        // console.log(thumbSlideTotalHeight);
        const nbrSlidePossible = Math.floor(mainSliderFirstSlideHeight / thumbSlideTotalHeight) - 1; // 6

        const thumbTotalHeight = nbrSlidePossible * thumbSlideTotalHeight;

        swiper.params.slidesPerView = nbrSlidePossible;
        this.sliderThumb.style.height = `${thumbTotalHeight}px`;
      }
    }
  );
}
